export default {
  pageTitle: '配管修理サービス',
  metaDescription: 'TEFは重要なプロセス配管の健全性を回復し、ダウンタイムを防止するための配管修理・メンテナンスサービスを提供します。',
  sidebar: {
    heading: 'メンテナンス＆修繕一覧',
    weldingOverlay: '肉盛り溶接',
    patching: 'パッチ補修',
    piping: '配管',
    reshell: 'シェル取替え',
    retubing: 'チューブ取替え',
  },
  title: '配管',
  heading: '総合的な配管製作・溶接サービス',
  paragraph1: '当社は、お客様固有のご要望に合わせた配管システムの製作、溶接、据付けを専門としております。プロジェクトの内容に応じて、自社工場または現場のいずれでも製作対応が可能であり、柔軟なサービスをご提供いたします。',
  paragraph2: '精密な溶接から確実な据付けまで、経験豊富な専門チームが工程のあらゆる段階で最高水準の品質を確保いたします。現場対応サービスにより、ダウンタイムを最小限に抑えつつ効率を高め、お客様の業務にシームレスに統合される信頼性の高いソリューションをご提供いたします。',
  steps: {
    step1: '工場内溶接',
    step2: '配管据付け',
    step3: 'サポート据付け',
    step4: '配管据付け',
    step5: 'サポート据付け',
    step6: 'サポート据付け',
    step7: 'サポート据付け',
  },
};
